var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "space-section panel panel-bordered" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [
      _c(
        "div",
        { staticClass: "picture-grid" },
        _vm._l(_vm.pictureConfigs, function (config) {
          return _c("div", { key: config.field, staticClass: "picture-card" }, [
            _c("div", { staticClass: "picture-card-header" }, [
              _c("div", [
                _c("h5", { staticClass: "picture-title" }, [
                  _vm._v(_vm._s(config.label)),
                ]),
                _c("p", { staticClass: "picture-helper mb-0" }, [
                  _vm._v(_vm._s(config.helper)),
                ]),
              ]),
              _vm.uploadingField === config.field
                ? _c("span", { staticClass: "uploading-text" }, [
                    _vm._v("Uploading..."),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "picture-preview-wrapper" }, [
              _vm.pictureUrl(config.field)
                ? _c("img", {
                    staticClass: "img img-fluid picture-preview",
                    attrs: {
                      src: _vm.pictureUrl(config.field),
                      alt: config.label,
                    },
                  })
                : _c("div", { staticClass: "picture-placeholder" }, [
                    _vm._v("No image uploaded"),
                  ]),
            ]),
            _c("div", { staticClass: "file-input-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default btn-sm file-input-button",
                  attrs: {
                    type: "button",
                    disabled:
                      _vm.disabled || _vm.uploadingField === config.field,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openFilePicker(config.field)
                    },
                  },
                },
                [_vm._v(" Choose file ")]
              ),
              _c("span", { staticClass: "file-input-name" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.selectedFileNames[config.field] || "No file chosen"
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("input", {
              ref: config.field,
              refInFor: true,
              staticClass: "file-input-native",
              attrs: {
                type: "file",
                accept: "image/*",
                disabled: _vm.disabled || _vm.uploadingField === config.field,
              },
              on: {
                change: function ($event) {
                  return _vm.upload(config.field, config.label, $event)
                },
              },
            }),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [_vm._v("Space Pictures")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }